module.exports = __webpack_public_path__ + "img/beat-hb-2020-masthead-segment.06386e7d.webp";